import React from "react";

export type ResultCountsProps = {
  endIndex: number;
  label?: string;
  startIndex: number;
  totalResults: number;
};

const ResultCounts: React.FC<ResultCountsProps> = ({
  endIndex,
  label = "Results",
  startIndex,
  totalResults,
}) => {
  if (totalResults === 0 || startIndex > totalResults) {
    return null;
  }

  return (
    <div className="text-xs" data-testid="result-count">
      <span className="font-bold">{`${label} ${startIndex}-${endIndex}`}</span>
      {` of ${totalResults}`}
    </div>
  );
};

export default ResultCounts;
